<template>
<a href="#win">
  <div :class="{'scroll-down': true, 'visible': visible}">
    <transition name="fade-escape">
      <escape-the-rut v-if="isVisible('home')" />
    </transition>
    <transition name="fade-wander">
      <wander-and-win v-if="isNotVisible('home') && isNotVisible('win')" />
    </transition>
  </div>
</a>
</template>

<script>
import WanderAndWin from './WanderAndWin.vue'
import EscapeTheRut from './EscapeTheRut.vue'

export default{
  name: 'scroll-down',
  components: {
    'wander-and-win': WanderAndWin,
    'escape-the-rut': EscapeTheRut
  },
  props: {
    active: String,
    delay: {
      required: false,
      default: 5000,
      type: Number
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    isVisible(section) {
      return this.visible && this.active && this.active === section
    },
    isNotVisible(section) {
      return this.visible && this.active && this.active !== section
    },
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    start() {
      this.timeout = setTimeout(this.show.bind(this), this.delay)
    },
    stop() {
      this.hide()
      if (this.timeout) clearTimeout(this.timeout)
    },
    reset() {
      this.stop()
      this.start()
    }
  },
  mounted() {
    this.start()
  },
  destroyed() {
    this.stop()
  }
}
</script>

<style scoped lang="scss">
/** scroll-down **/
@import '../../theme';

$speed: $t-s;

.scroll-down {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: zespri-layer(scroll-bug);
  display: none;

  @include media-vertical-breakpoint-up(sm) {
    display: block;
  }
}

.fade-escape-enter-active,
.fade-wander-enter-active {
  transition: opacity $speed linear #{$speed * 4};
}

.fade-escape-leave-active,
.fade-wander-leave-active {
  transition: opacity $speed linear 0s;
}

.fade-escape-enter,
.fade-escape-leave-to,
.fade-wander-enter,
.fade-wander-leave-to {
  opacity: 0;
}

</style>
